// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G5by","question":"styles_question__liJMN","description":"styles_description__27iUp"};